import React, { useState, useEffect, useRef } from 'react';

const FullscreenImageViewer = ({ src, alt, onClose }) => {
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const lastPos = useRef({ x: 0, y: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = Math.sign(e.deltaY) * -1; // up => zoom in
    setZoom(prev => {
      const step = 0.25;
      let next = prev + (delta * step);
      return Math.min(Math.max(1, next), 8);
    });
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setDragging(true);
    lastPos.current = { x: e.clientX, y: e.clientY };
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    const dx = e.clientX - lastPos.current.x;
    const dy = e.clientY - lastPos.current.y;
    lastPos.current = { x: e.clientX, y: e.clientY };
    setOffset(prev => ({ x: prev.x + dx, y: prev.y + dy }));
  };

  const handleMouseUp = () => setDragging(false);

  const handleDoubleClick = () => {
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  };

  return (
    <div
      ref={containerRef}
      onWheel={handleWheel}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/90 cursor-grab"
      onDoubleClick={handleDoubleClick}
      onMouseDown={handleMouseDown}
      style={{ touchAction: 'none' }}
      onClick={(e) => { if (e.target === containerRef.current) onClose && onClose(); }}
    >
      <img
        src={src}
        alt={alt}
        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/api/assets/placeholder.png'; }}
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
          transition: dragging ? 'none' : 'transform 0.12s ease-out',
          maxWidth: 'none',
          maxHeight: 'none',
          height: '80vh',
          width: 'auto'
        }}
      />
      <button onClick={() => onClose && onClose()} className="absolute top-6 right-6 text-white bg-black/40 p-2 rounded">Close</button>
    </div>
  );
};

export default FullscreenImageViewer;
